import { useContext, useEffect, useState } from 'react';
import { appContext, AppContext } from '../../../context/AppContext';
import { Conversation } from '@anticatrade/shared';

const DEFAULT_LIMIT = 20;

const useConversations = () => {
	const [conversations, setConversations] = useState<Conversation[]>([]);
	const [count, setCount] = useState<number>();
	const [page, setPage] = useState<number>(1);
	const [isLoading, setIsLoading] = useState<boolean>(true);

	const { api, handleError } = useContext(appContext as React.Context<AppContext>);

	useEffect(() => {
		const fetchData = async () => {
			setIsLoading(true);
			try {
				const conversationsRes = await api.conversations(page, DEFAULT_LIMIT);
				setConversations(conversationsRes.conversations);
				setCount(conversationsRes.count);
			} catch (err) {
				handleError(err as Error);
			}
			setIsLoading(false);
		};

		fetchData();
	}, [page]);

	return {
		isLoading,
		conversations,
		count,
		page,
		setPage,
		limit: DEFAULT_LIMIT,
	};
};

export { useConversations };
